
import { UserRole } from '@/lib/supabase';

// Define permission types
export type Permission = 
  | 'view_analysis'
  | 'create_analysis'
  | 'export_results'
  | 'view_audit_logs'
  | 'manage_users'
  | 'access_admin_panel'
  | 'access_analytics'
  | 'manage_system_settings'
  | 'manage_api_keys';

// Role to permissions mapping
export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  user: [
    'view_analysis',
    'create_analysis'
  ],
  analyst: [
    'view_analysis',
    'create_analysis',
    'export_results',
    'access_analytics'
  ],
  admin: [
    'view_analysis',
    'create_analysis',
    'export_results',
    'view_audit_logs',
    'manage_users',
    'access_admin_panel',
    'access_analytics',
    'manage_system_settings',
    'manage_api_keys'
  ]
};

// Check if user has specific permission
export const hasPermission = (userRole: UserRole | undefined, permission: Permission): boolean => {
  if (!userRole) return false;
  
  const permissions = ROLE_PERMISSIONS[userRole];
  return permissions.includes(permission);
};

// Check if user has any of the specified permissions
export const hasAnyPermission = (userRole: UserRole | undefined, permissions: Permission[]): boolean => {
  if (!userRole) return false;
  
  return permissions.some(permission => hasPermission(userRole, permission));
};

// Check if user has all of the specified permissions
export const hasAllPermissions = (userRole: UserRole | undefined, permissions: Permission[]): boolean => {
  if (!userRole) return false;
  
  return permissions.every(permission => hasPermission(userRole, permission));
};
